import { httpSimulasi } from '@/plugins/api'
import { httpbranch } from '@/plugins/api'

export const getVehicleTypes = () => {
  const url = `/credit-simulation-v2/param-unit-genre`

  return httpSimulasi.post(
    url,
    {},
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  )
}

export const getVehicleBrands = (typeId = '') => {
  const url = `/commonapi/getParamBrandByObjectGroupId`

  return httpbranch.post(
    url,
    {
      objectGroupId: typeId, // sama seperti this.selectedunitID
    },
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  )
}

export const getVehicleModels = (brandId = '') => {
  const url = `/objekbrand/${brandId}/objekmodel`

  return httpSimulasi.get(url)
}
